import {
    Button,
    Col,
    Form,
    Row
} from 'antd'
import lodash from 'lodash'
import React, { useEffect, useRef, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import { getUrlPushWrapper } from '../../../routes/routes'
import AgentTypeheadComponent from '../../../components/_utils/AgentTypeheadComponent'
import {getAllWithdrawalsFxn} from "../../xTravelTransfer/actions";
import { displayDate, displayTime } from '../../../components/_utils/appUtils'
import {ColumnWidth} from "../../WebComponent/columnWidth";

const XTravelWithdrawalList = () => {
    const [totalApplication, setTotalApplication] = useState(0)
    let [tableSearch, setTableSearch] = useState(false)
    let [filters, setFilters] = useState({})
    let [agentId, setAgentId] = useState('')
    const dispatch = useDispatch()
    let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
    const tableAppRef = useRef()

    let apiRequest = params => {
        return new Promise(async resolve => {
            let resp = await getParamsForApplicationList()
            params = { ...params, ...resp }
            if (!params.results) {
                params.results = 50
                params.count = 50
            }
            if (tableSearch) {
                params.page = 1
            }
            try {
                setFilters(params)
                let resp = await dispatch(getAllWithdrawalsFxn({
                    ...params, regExFilters: ['referralNo', 'reason', 'agentId']
                }))
                setTotalApplication(resp.total)
                resolve(resp)
            } catch (e) {
            }
        })
    }

    useEffect(() => {
        setFieldByParams()
    }, [])

    const setFieldByParams = async () => {
        let resp = await getParamsForApplicationList()
        if (resp.agentId) {
            setAgentId(resp.agentId)
        }
    }

    const getParamsForApplicationList = () => {
        return new Promise(resolve => {
            let searchParams = new URLSearchParams(window.location.search)
            let agentId = searchParams.get('agentId')
            let obj = {}
            if (agentId) {
                obj.agentId = agentId
            }
            resolve(obj)
        })
    }

    const searchFxn = async () => {
        let obj = {}
        if (agentId) {
            obj.agentId = agentId
        }
        dispatch(
            getUrlPushWrapper('x-travel-withdrawal-list', {
                ...obj
            })
        )
        setTableSearch(true)
        setTimeout(() => {
            if (tableAppRef && tableAppRef.current) {
                tableAppRef.current.reload()
            }
        }, 200)
    }
    const clearFxn = async () => {
        let obj = {}
        setAgentId('')
        dispatch(
            getUrlPushWrapper('x-travel-withdrawal-list', {
                ...obj
            })
        )
        setTableSearch(true)
        setTimeout(() => {
            tableAppRef.current.reload()
        }, 200)
    }

    let [pageState, setPageState] = useState({ count: 10, page: 1, groupCount: 10, groupPage: 1 })

    const columns = [
        {
            key: '_id',
            title: '#',
            dataIndex: '_id',
            width: 50,
            render: (item, record, index) => {
                return (
                    <>
                        {pageState.count * (pageState.page - 1) + (index + 1)}
                    </>
                )
            }
        },
        {
            title: 'Agent Name',
            key: 'agentId',
            dataIndex: 'agentId',
            width: 150,
            render: (item) => {
                console.log(item, "item0000000")
                return (
                    item ? <div>
                        {item && item.name ? item.name : ''}<br />
                        ({item.companyName})
                    </div> : null
                )
            }
        },

        {
            title: 'Referral No',
            key: 'referralNo',
            dataIndex: 'referralNo',
            width: 120
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            width: 120,
            render: (item) => `Rs. ${item}`
        },
        {
            title: 'Status',
            key: 'status',
            dataIndex: 'status',
            width: 100
        },
        {
            title: 'Type',
            key: 'withdrawalType',
            dataIndex: 'withdrawalType',
            width: 140
        },
        {
            title: 'Reason',
            key: 'reason',
            dataIndex: 'reason',
            width: 200
        },
        {
            title: 'Date',
            key: 'date',
            dataIndex: 'date',
            width: 150,
            render: (item) => `${displayDate(item)}, ${displayTime(item)}`
        }
    ]

    const loadColumns = () => {
        return columns.filter(col => col.hidden !== true)
    }

    const filterBlock = (
        <Row gutter={16}>
            <Col md={6} sm={6} xs={10} lg={6}>
                <div className='sort-box-table custom-sort-box-new'>
                    <AgentTypeheadComponent
                        key={agentId}
                        agentId={agentId}
                        dispatch={dispatch}
                        onSelect={item => setAgentId(item)}
                        blockStatus={false}
                    />
                </div>
            </Col>
            <Col md={4} sm={4} xs={8} lg={4}>
                <Button onClick={searchFxn} className={'roundBtn'}>Search</Button>
                <Button onClick={clearFxn} className={'roundBtn'}>Clear</Button>
            </Col>
        </Row>
    )

    return (
        <React.Fragment>
            <div className='row mt-4'>
                <div className='col-lg-12'>
                    <div className='card'>
                        <div className='table-head d-flex align-items-center all-student-search' style={{ height: 60 }}>
                            <Button
                                onClick={() => dispatch(getUrlPushWrapper('dashboard'))}
                                className='roundGoBackBtn'
                                icon='arrow-left'>
                                Back
                            </Button>
                            <h5>All XTravelWorld Withdrawals</h5>
                            <div className='sort-box-table mark-btn'>( Total : {totalApplication} )</div>
                        </div>
                        <div className='card-body table-responsive'>
                            {user.userType === 'admin' ? filterBlock : null}
                            <TableComp
                                columns={loadColumns()}
                                rowKey={(item, index) => index}
                                apiRequest={apiRequest}
                                pagination={{
                                    position: 'top',
                                    showSizeChanger: true,
                                    pageSizeOptions: ['10', '20', '30', '50'],
                                    defaultPageSize: 10,
                                    current: filters.page || 1
                                }}
                                ref={tableAppRef}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = ({ global }) => ({
    currentUserRights: global.currentUserRights
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
const WrappedComponent = Form.create()(XTravelWithdrawalList)
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WrappedComponent)
